// Features that are built but not launched yet. Flip to true to enable.
// Deliberately constants, not env vars.

// Email invites to events: the promoter's "Invite brands" tab and the invite
// banner on the event page. Needs the API's matching switch
// (EMAIL_INVITES_ENABLED in src/services/eventInvites.js) turned on too.
export const EMAIL_INVITES_ENABLED = false;
